import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { environment } from 'src/environments/environment';
import { AppStateService } from '../auth/services/app-state.service';

@Injectable({
	providedIn: 'root',
})
export class QuoteResolver implements Resolve<boolean> {
	constructor(
		private appStateService: AppStateService,
		private platformLocation: PlatformLocation,
	) {}

	async resolve(route: ActivatedRouteSnapshot): Promise<boolean> {
		try {
			const isPowerKiosk =
				this.platformLocation.href.includes('localhost') ||
				this.platformLocation.href.includes('powerkioskdirect') ||
				this.platformLocation.href.includes('smartenrollpk') ||
				this.platformLocation.href.includes('enrollpower');

			let salesCode = environment.production ? 'pkec_ep' : 'pkec_test_ep';
			if (route.queryParamMap.get('salesCode')) {
				salesCode = route.queryParamMap.get('salesCode');
			} else if (!isPowerKiosk) {
				salesCode = '';
			}

			await this.appStateService.setPromoCode(isPowerKiosk, salesCode);

			if (this.appStateService.promoCode) {
				this.appStateService.setReady({ app: true });
			}

			return true;
		} catch (e) {
			console.error(e);
		}

		return false;
	}
}
